const it = {
  'About this page': 'Informazioni su questa pagina',
  'About this Page': 'Informazioni su questa pagina',
  'Actions': 'Azioni',
  'Active Alarms': 'Allarmi Attivi',
  'Admin': 'Amministratore',
  'Admin & User': 'Amministratore e Utente',
  'Admin Secret Key': 'Chiave Segreta Amministratore',
  'Alarm Queue': 'Coda Allarmi',
  'All labels': 'Tutte le etichette',
  'All serial numbers': 'Tutti i numeri di serie',
  'All steps': 'Tutti gli step',
  'All Testspecs': 'Tutti i Testspec',
  'All Versions': 'Tutte le versioni',
  'All versions': 'Tutte le versioni',
  'Analyzing failures...': 'Analisi dei guasti...',
  'Apply': 'Applica',
  'Apply Date Filter': 'Applica filtro data',
  'Apply filters': 'Applica filtri',
  'Apply Limits': 'Applica limiti',
  'ATE SW Version': 'Versione ATE SW',
  'ATE SW version': 'Versione ATE SW',
  'ATE Software Version': 'Versione Software ATE',
  'Browse Files': 'Sfoglia file',
  'Cancel': 'Annulla',
  'Chart PNG': 'PNG grafico',
  'Choose the date range, software version, and serial numbers to analyze.': 'Scegli intervallo date, versione software e numeri di serie da analizzare.',
  'Clear': 'Pulisci',
  'Close': 'Chiudi',
  'Co-failing Steps': 'Step con guasto associato',
  'Comma separated': 'Separati da virgola',
  'Confirm Deletion': 'Conferma eliminazione',
  'Control Chart Analysis': 'Analisi grafico di controllo',
  'Control Charts': 'Grafici di controllo',
  'Count': 'Conteggio',
  'Create a new account': 'Crea un nuovo account',
  'CSV': 'CSV',
  'Data intake': 'Ingresso dati',
  'Data library': 'Archivio dati',
  'Date Filter': 'Filtro data',
  'End date': 'Data fine',
  'End Date': 'Data fine',
  'Evidence-ranked failures': 'Guasti ordinati per evidenza',
  'Example: R004': 'Esempio: R004',
  'Example Evidence': 'Esempi di evidenza',
  'Expand': 'Espandi',
  'Expand chart': 'Espandi grafico',
  'Export as PNG': 'Esporta come PNG',
  'Export Data CSV': 'Esporta dati CSV',
  'Export PNG': 'Esporta PNG',
  'Exports': 'Esportazioni',
  'Fail count': 'Conteggio guasti',
  'Fail Count': 'Conteggio guasti',
  'Fail percentage': 'Percentuale guasti',
  'Fail rate': 'Tasso guasti',
  'Failed Products': 'Prodotti falliti',
  'Failure forecasting': 'Previsione guasti',
  'Failure intelligence': 'Intelligenza guasti',
  'Failure priority': 'Priorità guasti',
  'File': 'File',
  'Filename': 'Nome file',
  'Filter by File Name': 'Filtra per nome file',
  'Filter by Serial Number': 'Filtra per numero di serie',
  'Filters': 'Filtri',
  'Generated Files': 'File generati',
  'Global ID': 'ID globale',
  'Hide Table': 'Nascondi tabella',
  'ID': 'ID',
  'Individual Chart': 'Grafico individuale',
  'Investigation Plan': 'Piano di investigazione',
  'Investigate': 'Investiga',
  'Language': 'Lingua',
  'Last 30 Days': 'Ultimi 30 giorni',
  'Last 7 Days': 'Ultimi 7 giorni',
  'Limits': 'Limiti',
  'Loading...': 'Caricamento...',
  'Loading Chart...': 'Caricamento grafico...',
  'Loading Pareto data...': 'Caricamento dati Pareto...',
  'Loading predictive data...': 'Caricamento dati predittivi...',
  'Loading summary data...': 'Caricamento riepilogo...',
  'Make Bigger': 'Ingrandisci',
  'Minimum Severity': 'Severità minima',
  'ML Runs': 'Esecuzioni ML',
  'Monthly Failure Rate': 'Tasso di guasto mensile',
  'MR Chart': 'Grafico MR',
  'Name': 'Nome',
  'Near/Outside': 'Vicino/Fuori limite',
  'No alarms matched the selected filters.': 'Nessun allarme corrisponde ai filtri selezionati.',
  'No data found': 'Nessun dato trovato',
  'No files were recorded for this run.': 'Nessun file registrato per questa esecuzione.',
  'No Pareto data found for these filters.': 'Nessun dato Pareto trovato per questi filtri.',
  'No repeated co-failing step was found.': 'Nessuno step con guasto associato ripetuto trovato.',
  'No status summary data found for these filters.': 'Nessun riepilogo stato trovato per questi filtri.',
  'No steps available.': 'Nessuno step disponibile.',
  'Normal User': 'Utente normale',
  'Observation': 'Osservazione',
  'Page Help': 'Aiuto pagina',
  'Page help': 'Aiuto pagina',
  'Pareto Failure Analysis': 'Analisi guasti Pareto',
  'Pareto table': 'Tabella Pareto',
  'Pass / fail split': 'Divisione pass/fail',
  'PASS count': 'Conteggio PASS',
  'PASS Probability': 'Probabilità PASS',
  'Password': 'Password',
  'Pie Chart Analysis': 'Analisi grafico a torta',
  'Prediction': 'Previsione',
  'Predicted FAIL': 'Previsto FAIL',
  'Predicted Label': 'Etichetta prevista',
  'Predicted PASS': 'Previsto PASS',
  'Predictive Failure Analysis': 'Analisi predittiva guasti',
  'Primary step': 'Step primario',
  'Process Capability Report': 'Report capacità di processo',
  'Process stability': 'Stabilità processo',
  'Production quality': 'Qualità produzione',
  'Recent': 'Recente',
  'Register': 'Registrati',
  'Register for Data Analyzer': 'Registrazione Data Analyzer',
  'Reset': 'Reimposta',
  'Reset to Default': 'Ripristina predefiniti',
  'Role': 'Ruolo',
  'Root Cause Alarms': 'Allarmi causa radice',
  'Root Cause Analysis': 'Analisi causa radice',
  'Root Cause Analyzer': 'Analizzatore causa radice',
  'Run Analysis': 'Esegui analisi',
  'Running root cause analysis...': 'Analisi causa radice in corso...',
  'Search global ID': 'Cerca ID globale',
  'Search serial number': 'Cerca numero di serie',
  'Secure Signup': 'Registrazione sicura',
  'Select': 'Seleziona',
  'Select a run': 'Seleziona esecuzione',
  'Select a step': 'Seleziona step',
  'Select AteSwVersion': 'Seleziona AteSwVersion',
  'Select Files': 'Seleziona file',
  'Select step': 'Seleziona step',
  'Select UUT Status': 'Seleziona stato UUT',
  'Serial': 'Seriale',
  'Serial number': 'Numero di serie',
  'Serial Number': 'Numero di serie',
  'Serial numbers': 'Numeri di serie',
  'Set LSL': 'Imposta LSL',
  'Set Production Goal': 'Imposta obiettivo produzione',
  'Set Specification Limits': 'Imposta limiti specifica',
  'Set USL': 'Imposta USL',
  'Show Table': 'Mostra tabella',
  'Sign in to your account': 'Accedi al tuo account',
  'Sort by fail rate': 'Ordina per tasso guasti',
  'Sort by recent trend': 'Ordina per trend recente',
  'Sort by severity': 'Ordina per severità',
  'Sort by step number': 'Ordina per numero step',
  'Start date': 'Data inizio',
  'Start Date': 'Data inizio',
  'Step': 'Step',
  'Step Details': 'Dettagli step',
  'Step Frequency Analyzer': 'Analizzatore frequenza step',
  'Step Frequency and Fail Percentage': 'Frequenza step e percentuale guasti',
  'Step number': 'Numero step',
  'Step Number': 'Numero step',
  'Step Result': 'Risultato step',
  'Steps Analyzed': 'Step analizzati',
  'Total count': 'Conteggio totale',
  'Total Sessions': 'Sessioni totali',
  'UCL/LCL Calculator': 'Calcolatore UCL/LCL',
  'Unit status': 'Stato unità',
  'Unlock Insights': 'Sblocca insight',
  'Upload': 'Carica',
  'Upload Files': 'Carica file',
  'Upload Queue': 'Coda caricamento',
  'Username': 'Nome utente',
  'UUT Status': 'Stato UUT',
  'UUT Status Summary': 'Riepilogo stato UUT',
  'Value': 'Valore',
  'View All Files': 'Visualizza tutti i file',
  'Visible Measurements': 'Misure visibili',
  'When Primary Fails': 'Quando il primario fallisce',
  'Choose a Burn-In View': 'Scegli una vista Burn-In',
  'Open Latest Overview': "Apri l'ultima panoramica",
  'Burn-in uploads': 'Upload burn-in',
  'Source files': 'File sorgente',
  'Views available': 'Viste disponibili',
  'Categories': 'Categorie',
  'Category': 'Categoria',
  'Open view': 'Apri vista',
  'Open Dashboard': 'Apri dashboard',
  'Production Analytics Hub': 'Hub Analitiche Produzione',
  'Root Problem Hub': 'Hub Problemi Radice',
  'Burn-In Analytics Hub': 'Hub Analitiche Burn-In',
  'Open analytics by area': 'Apri le analisi per area',
  'Organized navigation': 'Navigazione organizzata',
  'Main database': 'Database principale',
  'Root cause': 'Causa radice',
  'Separate burn-in database': 'Database burn-in separato',
  'Burn-in analytics hub': 'Hub analitiche burn-in',
  'What data am I seeing?': 'Quali dati sto vedendo?',
  'Close help': 'Chiudi aiuto',
  'This page groups the standard production analytics into one organized navigation hub.': 'Questa pagina raggruppa le analisi standard di produzione in un unico hub di navigazione organizzato.',
  'Use it to open overview, failure, flow, measurement, and prediction pages from the main production database.': 'Usala per aprire pagine di panoramica, guasti, flusso, misure e predizione dal database principale di produzione.',
  'The cards do not calculate data themselves; they route you to the selected analysis page.': 'Le card non calcolano dati da sole; ti portano alla pagina di analisi selezionata.',
  'This hub reduces sidebar clutter while keeping every major production chart easy to reach.': 'Questo hub riduce l\'affollamento della sidebar mantenendo ogni grafico principale di produzione facile da raggiungere.',
  'The grouped layout helps users choose the right analysis based on the question they want to answer.': 'Il layout raggruppato aiuta l\'utente a scegliere l\'analisi giusta in base alla domanda a cui vuole rispondere.',
  'This page groups the deeper failure investigations used to separate likely triggers from secondary symptoms.': 'Questa pagina raggruppa le indagini più profonde sui guasti usate per separare i trigger probabili dai sintomi secondari.',
  'Use it to open first-fail, margin-risk, hotspot, cascade, retry, and late-stage failure investigations.': 'Usala per aprire indagini su primo fail, rischio margine, hotspot, cascata, retry e fail nelle fasi finali.',
  'Each destination page uses a different logic model, such as first-fail position, baseline fail-rate comparison, retry totals, or downstream failure spread.': 'Ogni pagina di destinazione usa una logica diversa, come posizione del primo fail, confronto col tasso di fail base, totali retry o diffusione dei guasti a valle.',
  'The hub itself is only an organizer, but it helps users choose the right root-cause method faster.': 'L\'hub è solo un organizzatore, ma aiuta a scegliere più velocemente il metodo corretto di root cause.',
  'This keeps advanced analysis visible without overloading the dashboard with many direct buttons.': 'Questo mantiene visibili le analisi avanzate senza sovraccaricare la dashboard con molti pulsanti diretti.',
  'This page is the single entry point for all burn-in charts and analytics.': 'Questa pagina è il punto di ingresso unico per tutti i grafici e le analisi burn-in.',
  'Use this hub to choose which burn-in chart you want instead of browsing many sidebar buttons.': 'Usa questo hub per scegliere quale grafico burn-in vuoi vedere invece di scorrere molti pulsanti nella sidebar.',
  'All views here read from the separate burn_in_results.db database.': 'Tutte le viste qui leggono dal database separato burn_in_results.db.',
  'The cards group charts by theme such as failures, timing, sources, measurements, and specifications.': 'Le card raggruppano i grafici per tema, come guasti, tempi, sorgenti, misure e specifiche.',
  'Open one view, inspect it, then come back here to switch analyses quickly.': 'Apri una vista, analizzala e poi torna qui per cambiare rapidamente analisi.',
  'This page imports new product test result files.': 'Questa pagina importa nuovi file di risultati test prodotto.',
  'CSV files are uploaded to the backend.': 'I file CSV vengono caricati nel backend.',
  'Global product/session information is saved in global_metadata.': 'Le informazioni globali di prodotto/sessione vengono salvate in global_metadata.',
  'Each test branch or step result is saved in step_data.': 'Ogni ramo di test o risultato step viene salvato in step_data.',
  'The charts and ML model use these stored rows after upload.': 'I grafici e il modello ML usano queste righe salvate dopo il caricamento.',
  'This page imports the new burn-in spreadsheet format into a separate database.': 'Questa pagina importa il nuovo formato foglio burn-in in un database separato.',
  'Spreadsheet and CSV burn-in files are uploaded to the backend.': 'I file burn-in spreadsheet e CSV vengono caricati nel backend.',
  'Each import creates one row in burn_in_uploads inside burn_in_results.db.': 'Ogni import crea una riga in burn_in_uploads dentro burn_in_results.db.',
  'Every parsed measurement row is stored in burn_in_measurements with both normalized fields and raw values.': 'Ogni riga misura analizzata viene salvata in burn_in_measurements con campi normalizzati e valori grezzi.',
  'The summary cards and preview table read from this dedicated burn-in database.': 'Le card di riepilogo e la tabella anteprima leggono da questo database burn-in dedicato.',
  'Review uploaded test sessions, inspect step data, and manage records used by the analysis pages.': 'Rivedi le sessioni di test caricate, controlla i dati degli step e gestisci i record usati dalle pagine di analisi.',
  'Select Start Date': 'Seleziona data inizio',
  'Select End Date': 'Seleziona data fine',
  'Filter database rows by Step Number': 'Filtra le righe database per numero step',
  'Sort Oldest to Newest': 'Ordina dal piu vecchio al piu recente',
  'Sort Newest to Oldest': 'Ordina dal piu recente al piu vecchio',
  'Hide Database Data': 'Nascondi dati database',
  'Show All Database Data': 'Mostra tutti i dati database',
  'Delete Selected': 'Elimina selezionati',
  'Confirm Delete Selected': 'Conferma eliminazione selezionati',
  'Are you sure you want to delete all records? This action cannot be undone.': 'Sei sicuro di voler eliminare tutti i record? Questa azione non puo essere annullata.',
  'Yes, Delete All': 'Si, elimina tutto',
  'Yes, Delete Selected': 'Si, elimina selezionati',
  'Delete All': 'Elimina tutto',
  'Machine': 'Macchina',
  'Station': 'Stazione',
  'Test Started': 'Test avviato',
  'Test Stopped': 'Test terminato',
  'Step Rows': 'Righe step',
  'View Steps': 'Vedi step',
  'Delete': 'Elimina',
  'No records found.': 'Nessun record trovato.',
  'Raw database data': 'Dati grezzi database',
  'Global metadata joined with step data': 'Metadati globali uniti ai dati step',
  'Loading database rows...': 'Caricamento righe database...',
  'File ID': 'ID file',
  'Started': 'Avviato',
  'Stopped': 'Terminato',
  'ATE SW': 'ATE SW',
  'Measure Type': 'Tipo misura',
  'Measure Value': 'Valore misura',
  'Limit Low': 'Limite basso',
  'Limit High': 'Limite alto',
  'Measure String': 'Stringa misura',
  'Limit String': 'Stringa limite',
  'No database rows found.': 'Nessuna riga database trovata.',
  'This page allows you to view, filter, and manage test records based on metadata extracted from uploaded files.': 'Questa pagina ti permette di vedere, filtrare e gestire i record di test basati sui metadati estratti dai file caricati.',
  'Sorting:': 'Ordinamento:',
  'Bulk Actions:': 'Azioni massive:',
  'You can delete selected records or delete all records with the action buttons at the top of the page.': 'Puoi eliminare i record selezionati oppure tutti i record usando i pulsanti azione in alto nella pagina.',
  'You can open this help modal anytime by clicking the "?" button.': 'Puoi aprire questa finestra di aiuto in qualsiasi momento cliccando il pulsante "?".',
  'Select Date': 'Seleziona data',
  'Today': 'Oggi',
  'Yesterday': 'Ieri',
  '7 Days Ago': '7 giorni fa',
  '30 Days Ago': '30 giorni fa',
  'Add test result files to populate the dashboard, charts, ML runs, and root-cause tools.': 'Aggiungi file di risultati test per popolare dashboard, grafici, esecuzioni ML e strumenti di root cause.',
  'Individual file size limit is 10MB': 'Il limite di dimensione per ogni file e 10MB',
  'Upload complete': 'Caricamento completato',
  'Upload progress': 'Avanzamento caricamento',
  'Upload successful!': 'Caricamento riuscito!',
  'Upload failed. Please try again.': 'Caricamento fallito. Riprova.',
  'This page allows you to upload hardware test data files, which are stored and made available for further analysis and visualization.': 'Questa pagina ti permette di caricare file di dati test hardware, che vengono salvati e resi disponibili per analisi e visualizzazioni successive.',
  'Click the button to select files from your computer.': 'Clicca il pulsante per selezionare i file dal tuo computer.',
  'Upload Progress:': 'Avanzamento caricamento:',
  'Displays real-time upload progress.': "Mostra l'avanzamento caricamento in tempo reale.",
  'Duplicate Detection:': 'Rilevamento duplicati:',
  'Skips files already uploaded.': 'Salta i file gia caricati.',
  'Metadata Extraction:': 'Estrazione metadati:',
  'Extracts machine ID, serial number, test times, and AteSwVersion.': 'Estrae ID macchina, numero di serie, tempi test e AteSwVersion.',
  'Step Data:': 'Dati step:',
  'Parses CSV test step data for analysis and charts.': 'Analizza i dati CSV degli step di test per analisi e grafici.',
  'Checking your session...': 'Verifica della sessione...',
  '{{count}} file(s) in view': '{{count}} file in vista',
  'No uploaded files in view': 'Nessun file caricato in vista',
  '{{count}} family(ies)': '{{count}} famiglie',
  'Loading…': 'Caricamento…',
  '+{{count}} more': '+{{count}} altri',
  'Upload files to see source families here.': 'Carica file per vedere qui le famiglie sorgente.',
  'PASS only count': 'Conteggio solo PASS',
  'PASS + FAIL count': 'Conteggio PASS + FAIL',
  'PASS only mean': 'Media solo PASS',
  'PASS + FAIL mean': 'Media PASS + FAIL',
  'Open Control Limits Calculator': 'Apri calcolatore limiti di controllo',
  'Export Table as CSV': 'Esporta tabella in CSV',
  'Export Table as PDF': 'Esporta tabella in PDF',
  'No Normal Distribution Data Available': 'Nessun dato distribuzione normale disponibile',
  'Help Information': 'Informazioni di aiuto',
  'Some filter options could not be loaded.': 'Alcune opzioni di filtro non sono state caricate.',
  'Failed to load root cause analysis. Please try again.': "Impossibile caricare l'analisi root cause. Riprova.",
  'Select a failing test step and get a ranked evidence report: enrichment against controls, timing, near-limit behavior, retries, and example units.': 'Seleziona uno step di test fallito e ottieni un report ordinato per evidenza: confronto con i controlli, timing, comportamento vicino ai limiti, retry e unità di esempio.',
  'Focus the analysis by primary step, date, software version, and serial number.': 'Focalizza l\'analisi per step primario, data, versione software e numero di serie.',
  'Unnamed step': 'Step senza nome',
  'fails': 'guasti',
  'Any start date': 'Qualsiasi data iniziale',
  'Any end date': 'Qualsiasi data finale',
  'No primary step selected': 'Nessuno step primario selezionato',
  'Analyzing...': 'Analisi in corso...',
  'Related-step probabilities': 'Probabilità degli step correlati',
  'Scores compare target-failure sessions with target-nonfailure sessions. Higher means stronger root-cause evidence.': 'I punteggi confrontano le sessioni con il guasto target con quelle senza il guasto target. Più alto significa evidenza root-cause più forte.',
  'Hide probabilities': 'Nascondi probabilità',
  'Show probabilities': 'Mostra probabilità',
  'Run the analysis to see related-step probabilities.': 'Esegui l\'analisi per vedere le probabilità degli step correlati.',
  'Evidence score bucket': 'Fascia punteggio evidenza',
  'Ranked candidates': 'Candidati ordinati',
  'Use the evidence lines to decide what to inspect first.': 'Usa le linee di evidenza per decidere cosa controllare per primo.',
  'About root cause analysis': 'Informazioni sull\'analisi root cause',
  'This page analyzes uploaded failure data for a primary test step and ranks related steps by root-cause probability.': 'Questa pagina analizza i dati di guasto caricati per uno step di test primario e ordina gli step correlati per probabilità di root cause.',
  'Use filters to narrow the data by time, ATE software version, and serial numbers.': 'Usa i filtri per restringere i dati per tempo, versione software ATE e numeri di serie.',
  'Failed to load UUT status summary data. Please try again.': 'Impossibile caricare i dati del riepilogo stato UUT. Riprova.',
  'Serial number filter options could not be loaded.': 'Le opzioni di filtro per numero di serie non sono state caricate.',
  'Compare PASS, FAIL, STOP, and UNCOMPLETE records across serial numbers.': 'Confronta i record PASS, FAIL, STOP e UNCOMPLETE tra i numeri di serie.',
  'Limit the summary by date range and serial numbers.': 'Limita il riepilogo per intervallo date e numeri di serie.',
  'Showing all serial numbers': 'Mostra tutti i numeri di serie',
  'Status counts by serial number': 'Conteggi stato per numero di serie',
  'Grouped bars show the count of each status for every serial number.': 'Le barre raggruppate mostrano il conteggio di ogni stato per ciascun numero di serie.',
  'Summary table': 'Tabella riepilogo',
  'Pass-only rows are highlighted to make healthy units easier to scan.': 'Le righe solo PASS sono evidenziate per rendere più facile individuare le unità sane.',
  'FAIL count': 'Conteggio FAIL',
  'STOP count': 'Conteggio STOP',
  'UNCOMPLETE count': 'Conteggio UNCOMPLETE',
  'Expanded UUT Status Summary Chart': 'Grafico riepilogo stato UUT espanso',
  'This page groups uploaded test records by serial number and counts how many PASS, FAIL, STOP, and UNCOMPLETE results each unit has.': 'Questa pagina raggruppa i record di test caricati per numero di serie e conta quanti risultati PASS, FAIL, STOP e UNCOMPLETE ha ogni unità.',
  'Use the filters to focus on a date range or specific serial numbers, then export the chart or table for reports.': 'Usa i filtri per focalizzarti su un intervallo di date o numeri di serie specifici, poi esporta il grafico o la tabella per i report.',
  'Loading predictions…': 'Caricamento previsioni…',
  'Failed to load predictions.json': 'Impossibile caricare predictions.json',
  'Loading probabilities…': 'Caricamento probabilità…',
  'Failed to load predictions': 'Impossibile caricare le previsioni',
  'No probability values found for this run.': 'Nessun valore di probabilità trovato per questa esecuzione.',
  'Probability of PASS (distribution)': 'Probabilità di PASS (distribuzione)',
  'count': 'conteggio',
  'Unable to load ML runs.': 'Impossibile caricare le esecuzioni ML.',
  'Unable to load the selected ML run.': "Impossibile caricare l'esecuzione ML selezionata.",
  'ML run failed. Check the server logs for details.': "L'esecuzione ML è fallita. Controlla i log del server per i dettagli.",
  'Unable to update pin state.': 'Impossibile aggiornare lo stato del pin.',
  'Pinned': 'In evidenza',
  'Run ML Model': 'Esegui modello ML',
  'No ML runs yet.': 'Nessuna esecuzione ML ancora.',
  'Start the first run to train the model and generate prediction files.': 'Avvia la prima esecuzione per addestrare il modello e generare i file di previsione.',
  'Loading selected run...': 'Caricamento esecuzione selezionata...',
  'Duration': 'Durata',
  'This run ended with an error.': 'Questa esecuzione è terminata con un errore.',
  'Run ID': 'ID esecuzione',
  'Ended': 'Terminato',
  'Database': 'Database',
  'Artifacts': 'Artefatti',
  'Predictions': 'Previsioni',
  'Pin Run': 'Metti in evidenza',
  'Unpin Run': 'Rimuovi evidenza',
  'Unable to load root-cause analysis.': 'Impossibile caricare l\'analisi root-cause.',
  'Finding likely root causes...': 'Ricerca delle cause radice più probabili...',
  'Branch': 'Ramo',
  'Predicted FAIL sessions': 'Sessioni FAIL previste',
  'Loading predictions...': 'Caricamento previsioni...',
  'Top Predicted FAIL Steps': 'Step FAIL previsti principali',
  'Unable to load log.': 'Impossibile caricare il log.',
  'Train Log': 'Log addestramento',
  'Predict Log': 'Log previsione',
  'Loading log...': 'Caricamento log...',
  'No log text.': 'Nessun testo nel log.',
  'No predicted FAIL sessions in this run.': 'Nessuna sessione FAIL prevista in questa esecuzione.',
  'Try another run, or run the model again after uploading more production data.': 'Prova un\'altra esecuzione, oppure riesegui il modello dopo aver caricato più dati di produzione.',
  'unknown': 'sconosciuto',
  'Overview': 'Panoramica',
  'Root Cause': 'Causa radice',
  'Failure Patterns': 'Pattern di guasto',
  'Logs': 'Log',
};

const reverseIt = Object.fromEntries(Object.entries(it).map(([en, translated]) => [translated, en]));

const getDictionary = (language) => (language === 'it' ? it : reverseIt);

const skippedParents = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'CODE', 'PRE', 'CANVAS']);

const translateText = (text, dictionary) => {
  const leading = text.match(/^\s*/)?.[0] || '';
  const trailing = text.match(/\s*$/)?.[0] || '';
  const normalized = text.trim().replace(/\s+/g, ' ');
  const translated = dictionary[normalized];
  return translated ? `${leading}${translated}${trailing}` : text;
};

const walkTextNodes = (root, callback) => {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();
  while (node) {
    const parentName = node.parentElement?.tagName;
    if (node.nodeValue?.trim() && !skippedParents.has(parentName)) {
      callback(node);
    }
    node = walker.nextNode();
  }
};

const translateAttributes = (root, dictionary) => {
  root.querySelectorAll?.('[placeholder], [aria-label], [contentlabel], [title]').forEach((element) => {
    ['placeholder', 'aria-label', 'contentlabel', 'title'].forEach((attribute) => {
      const value = element.getAttribute(attribute);
      if (!value) return;
      element.setAttribute(attribute, translateText(value, dictionary));
    });
  });
};

export const applyDomTranslations = (language) => {
  const root = document.getElementById('root');
  if (!root) return;
  const dictionary = getDictionary(language);
  walkTextNodes(root, (node) => {
    node.nodeValue = translateText(node.nodeValue, dictionary);
  });
  translateAttributes(root, dictionary);
};

export const observeDomTranslations = (language) => {
  const root = document.getElementById('root');
  if (!root) return () => {};

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyDomTranslations(language);
    });
  };

  const observer = new MutationObserver(schedule);
  observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true });
  schedule();

  return () => observer.disconnect();
};
